module.exports = __webpack_public_path__ + "img/susi.9aac41f6.jpg";